import { render, staticRenderFns } from "./SmChatIcon.vue?vue&type=template&id=25645eea&scoped=true&"
var script = {}
import style0 from "./SmChatIcon.vue?vue&type=style&index=0&id=25645eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25645eea",
  null
  
)

export default component.exports